import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7808d288"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pad-top" };
import Header from '@/components/organisms/Header.vue';
import Trading from './Trading.vue';
import Staking from './Staking.vue';
import Mypage from './Mypage.vue';
import TradeHistory from '@/components/pages/TradeHistory.vue';
import Tabs from '../organisms/Tabs.vue';
import { useStore } from '@/store/store';
import { onMounted, ref } from 'vue';
import { useAuthenticate } from '@/logics/auth';
import { useSettings } from '@/logics/settings';
import { useCurrencyPair } from '@/logics/currency_pair';
import { useRoute } from 'vue-router';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const store = useStore();
            const { getUserInfo } = useAuthenticate();
            const { setUserSettings } = useSettings();
            const { setCurrencyInfo, setCurrencyPair } = useCurrencyPair();
            const [{ userInfo, isAuth }] = (([__temp, __restore] = _withAsyncContext(() => Promise.all([
                getUserInfo(),
                setCurrencyInfo(),
                setCurrencyPair(),
                setUserSettings(),
            ]).catch((err) => {
                console.error(err);
                return [{ userInfo: null, isAuth: false }];
            }))),
                __temp = yield __temp,
                __restore(),
                __temp);
            const route = useRoute();
            const param = route.query['tab'];
            if (isAuth) {
                store.state.tab = param || 'trade';
            }
            else {
                store.state.tab = param === 'staking' && 'staking' || 'trade';
            }
            const changeTab = (tab) => {
                store.state.tab = tab;
                router.push({
                    path: '/trade',
                    query: { c: `${store.state.symbol.base}_${store.state.symbol.quote}`, tab: tab },
                });
            };
            const tradeKey = ref('trade0');
            const stakingKey = ref('staking0');
            const historyKey = ref('history0');
            const mypageKey = ref('mypage0');
            const reload = (tab) => {
                if (tab === 'trade') {
                    tradeKey.value = tradeKey.value === 'trade0' ? 'trade1' : 'trade0';
                }
                if (tab === 'staking') {
                    stakingKey.value = stakingKey.value === 'staking0' ? 'staking1' : 'staking0';
                }
                if (tab === 'history') {
                    historyKey.value = historyKey.value === 'history0' ? 'history1' : 'history0';
                }
                if (tab === 'mypage') {
                    mypageKey.value = mypageKey.value === 'mypage0' ? 'mypage1' : 'mypage0';
                }
            };
            const refreshCurrencyPair = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                yield setCurrencyPair();
                setTimeout(() => refreshCurrencyPair(), (_a = process.env.VUE_APP_SLEEP_GET_MARKET_INFO) !== null && _a !== void 0 ? _a : 3000);
            });
            onMounted(() => {
                router.push({
                    path: '/trade',
                    query: { c: `${store.state.symbol.base}_${store.state.symbol.quote}`, tab: param },
                });
                refreshCurrencyPair();
            });
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({ chart_full: _unref(store).state.chart.isFull })
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(_unref(store).state.isSmartPhone && 'fixed')
                    }, [
                        _createVNode(Tabs, {
                            class: "main-tabs",
                            onClick: changeTab,
                            onReload: reload,
                            "is-auth": _unref(isAuth)
                        }, null, 8, ["is-auth"]),
                        _createVNode(Header, {
                            isAuth: _unref(isAuth),
                            userInfo: _unref(userInfo)
                        }, null, 8, ["isAuth", "userInfo"])
                    ], 2),
                    _createElementVNode("div", _hoisted_1, [
                        _withDirectives((_openBlock(), _createBlock(Trading, {
                            "is-auth": _unref(isAuth),
                            key: tradeKey.value,
                            userInfo: _unref(userInfo)
                        }, null, 8, ["is-auth", "userInfo"])), [
                            [_vShow, _unref(store).state.tab === 'trade']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(Staking, {
                            key: stakingKey.value,
                            "is-auth": _unref(isAuth),
                            "user-info": _unref(userInfo)
                        }, null, 8, ["is-auth", "user-info"])), [
                            [_vShow, _unref(store).state.tab === 'staking']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(TradeHistory, {
                            "is-auth": _unref(isAuth),
                            key: historyKey.value
                        }, null, 8, ["is-auth"])), [
                            [_vShow, _unref(isAuth) && _unref(store).state.tab === 'history']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(Mypage, {
                            key: mypageKey.value,
                            "is-auth": _unref(isAuth),
                            "user-info": _unref(userInfo)
                        }, null, 8, ["is-auth", "user-info"])), [
                            [_vShow, _unref(store).state.tab === 'mypage']
                        ])
                    ])
                ], 2));
            };
        });
    }
});
